import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import People from '../components/People'
import Press from '../components/Press'
import Publications from '../components/Publications'
import Research from '../components/Research'
import Resources from '../components/Resources'
import Studies from '../components/Studies'
import GetInvolved from '../components/GetInvolved'

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/people',
      name: 'People',
      component: People
    },
    {
      path: '/studies',
      name: 'Studies',
      component: Studies
    },
    {
      path: '/research',
      name: 'Research',
      component: Research
    },
    {
      path: '/publications',
      name: 'Publications',
      component: Publications
    },
    {
      path: '/press',
      name: 'Press',
      component: Press
    },
    {
      path: '/resources',
      name: 'Resources',
      component: Resources
    },
    {
      path: '/get-involved',
      name: 'Get Involved',
      component: GetInvolved
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js